import { Box, Button, Divider, FormControl, IconButton, InputLabel, MenuItem, Paper, Popover, Select, SelectChangeEvent, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { HistoryOptions, OrderType } from '../atoms/portale'
import { t } from 'i18next'
import DeleteIcon from '@mui/icons-material/Delete'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'

type HistoryOptionsDialogPropsType = {
    open: boolean,
    anchorEl: HTMLElement,
    options: HistoryOptions,
    onAnnulla?: () => void,
    onSave?: (options: HistoryOptions) => void,
    onDelete?: (keep?: number, order?: OrderType) => void,
}

export const HistoryOptionsDialog: React.FC<HistoryOptionsDialogPropsType> = ({ open, anchorEl, options, onAnnulla, onSave, onDelete }) => {
    const [localOptions, setLocalOptions] = useState(options)
    const handleAnnulla = () => {
        onAnnulla && onAnnulla()
    }
    const handleSave = () => {
        onSave && onSave(localOptions)
    }
    const handleChangeNRow = (ev: SelectChangeEvent<string>) => {
        setLocalOptions(current => ({ ...current, nrow: Number.parseInt(ev.target.value) }))
    }
    const handleChangeOrder = (ev: SelectChangeEvent<OrderType>) => {
        setLocalOptions(current => ({ ...current, order: ev.target.value as OrderType }))
    }
    const handleDelete = () => {
        onDelete && onDelete()
        onAnnulla && onAnnulla()
    }
    const handleDeletePartial = () => {
        onDelete && onDelete(localOptions.nrow)
        onAnnulla && onAnnulla()
    }
    useEffect(() => {
        // console.log(`setLocalOptions: ${JSON.stringify(options)}`)
        setLocalOptions(options)
    }, [options, open])
    const handleClose = () => onAnnulla && onAnnulla()
    return (
        <>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Paper elevation={2} sx={{ minHeight: 100, minWidth: 100, p: 0.5, backgroundColor: '#f8f8f8' }}>
                    <Box sx={{ backgroundColor: '#f8f8f8', minHeight: 100, minWidth: 100, display: 'flex', flexDirection: 'column' }}>
                        <HsPopoverHeader title={t('Opzioni Applicazioni Recenti')} />
                        <HsPopoverBody>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                <Typography variant='body1'>Cancelllare storia applicazioni recenti?</Typography>
                                <IconButton size='small' color='primary' onClick={handleDelete}><DeleteIcon /></IconButton>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                <Typography variant='body1'>Mantenere le ultime {localOptions.nrow} righe?</Typography>
                                <IconButton size='small' color='primary' onClick={handleDeletePartial}><DeleteSweepIcon /></IconButton>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                <FormControl variant='standard' sx={{ flexGrow: 1 }}>
                                    <InputLabel id='numero-righe-storia-label'>Numero righe</InputLabel>
                                    <Select labelId='numero-righe-storia-label'
                                        label='Numero righe'
                                        size='small'
                                        sx={{ minWidth: 100 }}
                                        value={`${localOptions.nrow}`}
                                        onChange={handleChangeNRow}>
                                        <MenuItem value={10}>10 righe</MenuItem>
                                        <MenuItem value={20}>20 righe</MenuItem>
                                        <MenuItem value={30}>30 righe</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                <FormControl variant='standard' sx={{ flexGrow: 1 }}>
                                    <InputLabel id='order-by-storia-label'>Ordinamento</InputLabel>
                                    <Select labelId='order-by-storia-label'
                                        label='Ordinamento'
                                        size='small'
                                        sx={{ minWidth: 100 }}
                                        value={localOptions.order}
                                        onChange={handleChangeOrder}>
                                        <MenuItem value={'date'}>Ordinate per Data</MenuItem>
                                        <MenuItem value={'appl'}>Ordinate per Applicazione</MenuItem>
                                        <MenuItem value={'nrun'}>Ordinate per Numero Esecuzioni</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </HsPopoverBody>
                        <HsPopoverActions>
                            <Button size='small' onClick={handleAnnulla}>ANNULLA</Button>
                            <Button size='small' onClick={handleSave}>SALVA</Button>
                        </HsPopoverActions>
                    </Box>
                </Paper>
            </Popover>
        </>
    )
}

export const HsPopoverHeader = ({ title }: { title: string }) => {
    return (
        <>
            <Box sx={{ flexGrow: 0, px: 1.5, py: 0.5, textAlign: 'center' }}>
                <Typography variant='body1' color='primary' sx={{ fontWeight: 800 }}>{title}</Typography>
            </Box>
            <Divider />
        </>
    )
}

export const HsPopoverBody: React.FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => {
    return (
        <Box sx={{ flexGrow: 1, p: 1 }} >
            {children}
        </Box>
    )
}

export const HsPopoverActions: React.FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => {
    return (
        <>
            <Divider />
            <Box sx={{ flexGrow: 0, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                {children}
            </Box>
        </>
    )
}
